
import { Component, Prop, Vue } from 'nuxt-property-decorator'

@Component
export default class SideBarItem extends Vue {
  @Prop({ required: true }) readonly title!: string
  @Prop({ required: true }) readonly to!: string
}
